import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-navigation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButtonGroup = _resolveComponent("NButtonGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NButtonGroup, {
      disabled: _ctx.module.loading,
      items: _ctx.items,
      "model-value": '',
      "onUpdate:modelValue": _ctx.navigate
    }, null, 8, ["disabled", "items", "onUpdate:modelValue"])
  ]))
}